import { ProviderModel } from "../../../entities/";
import { BaseODataRepository } from "../../BaseODataRepository";

export class ProviderODataRepo extends BaseODataRepository<ProviderModel> {
  protected baseUrl = `/OData/providers`;
}
